
import MyAxios from '@/core/helpers/axios_helper';
import { defineComponent } from 'vue';
import VueSelect from 'vue-select';
import "vue-select/dist/vue-select.css";


const BorangPmkKnpFormPegawaiPsmComponent = defineComponent({
    components:{
        VueSelect,
    },
    props: {
        initialSelectedBahagianId: {type: Number, required: false, default: 0},
    },
    emits:['onBahagianChanged', 'onListPsmMaklumatChanged', 'psmListEmpty', 'psmNotSelected'],
    mounted() {
        this.getKementerian();
        this.getJabatan();
        this.getBahagian();
        this.syncSelectedBahagian();
    },
    methods:{
        async getKementerian(){
            console.log('get kementerian');
            try{
                const req = await MyAxios.get('/api/pengguna/perjawatan/naik-pangkat-mohon/kementerian');
                this.optKementerian = req.data;
            }catch(ex){
                console.log(ex);
            }
        },
        async getJabatan(){
            console.log('get jabatan');
            try{
                const req = await MyAxios.get('/api/pengguna/perjawatan/naik-pangkat-mohon/jabatan');
                this.optJabatan = req.data;
            }catch(ex){
                console.log(ex);
            }
        },
        async getBahagian(){
            console.log('get bahagian');
            try{
                const req = await MyAxios.get('/api/pengguna/perjawatan/naik-pangkat-mohon/bahagian');
                this.optBahagian = req.data;
            }catch(ex){
                console.log(ex);
            }
        },
        async getPsmMaklumat(){
            console.log('get psm maklumat');
            try{
                const req = await MyAxios.get('/api/pengguna/perjawatan/naik-pangkat-mohon/psm-maklumat?bahagian-id=' + this.form.bahagian?.id);
                this.optPsmMaklumat = req.data;
                console.log('list pegawai psm', this.optPsmMaklumat);
                this.$emit('onListPsmMaklumatChanged', this.optPsmMaklumat);
                if(this.optPsmMaklumat.length == 0){
                    console.log('psm list empty');
                    this.$emit('psmListEmpty', true);
                } else {
                    console.log('psm list not empty');
                    this.$emit('psmListEmpty', false);
                    // Auto-select the first PSM in the list to fill the field
                    this.form.psmMaklumat = this.optPsmMaklumat[0];
                }
            }catch(ex){
                console.log(ex);
            }
        },
        syncSelectedBahagian(){
            const selectedBahagianId = Number(this.initialSelectedBahagianId);
            if(selectedBahagianId > 0) {
                const bahagian = this.optBahagian.find((item: any) => item.id == selectedBahagianId);
                if(bahagian == null){
                    return;
                }
                const jabatan = this.optJabatan.find((item:any) => item.id == bahagian.psm_jabatan_id);
                if(jabatan == null){
                    return;
                }
                const kementerian = this.optKementerian.find((item:any) => item.id == jabatan.psm_kementerian_id);
                if(kementerian == null){
                    return;
                }

                setTimeout(() => {
                    this.form.kementerian = kementerian;
                    setTimeout(() => {
                        this.form.jabatan = jabatan;
                        setTimeout(() => {
                            this.form.bahagian = bahagian;
                        }, 100);
                    }, 100);
                }, 100);
            }
        }
    },
    watch:{
        'form.kementerian'(){
            console.log('kementerian changed, set jabatan to null');
            this.form.jabatan = null;
        },
        'form.jabatan'(){
            console.log('jabatan changed, set bahagaian to null');
            this.form.bahagian = null;
        },
        'form.bahagian'(){
            console.log('psm bahagian changed', this.form.bahagian);
            this.form.psmMaklumat = null; // Clear the selected PSM value
            this.getPsmMaklumat();
            this.$emit('onBahagianChanged', parseInt(this.form.bahagian?.id ?? 0));
        },
        'form.psmMaklumat'(newVal) {
            if (!newVal) {
                this.$emit('psmNotSelected', true);
            } else {
                this.$emit('psmNotSelected', false);
            }
        },
        initialSelectedBahagianId(){
            this.syncSelectedBahagian();
        }
    },
    data(){
        return {
            form: {
                bahagian:null as any,
                kementerian: null as any,
                jabatan: null as any,
                psmMaklumat: null as any,
            },
            optBahagian: [] as any[],
            optKementerian: [] as any[],
            optJabatan: [] as any[],
            optPsmMaklumat: [] as any[],
            showPSMNotFound: false,
        };
    },
    computed:{
        optJabatanFiltered():any[]{
            console.log('opt jabatan refresh', this.form);
            if(this.form.kementerian == null){
                return [];
            }
            const psmKementerianId = this.form.kementerian.id;
            return this.optJabatan.filter((item) => {
                if(item.psm_kementerian_id == psmKementerianId){
                    return true;
                }
                return false;
            });
        },
        optBahagianFiltered():any[]{
            console.log('opt bahagian refresh', this.form);
            if(this.form.jabatan == null){
                return [];
            }
            const psmJabatanId = this.form.jabatan.id;
            return this.optBahagian.filter((item) => {
                if(item.psm_jabatan_id == psmJabatanId){
                    return true;
                }
                return false;
            });
        },
        stylePSMNotFound(){
            if(this.showPSMNotFound == true) {
                const icon : any = this.$refs.tooltipIcon;
                return {
                position: 'absolute',
                top: (icon.offsetTop - 50) + 'px',
                left: (icon.offsetLeft) + 'px',
                };
            }
            return {
                display: 'none',
            };
        }
    },
});

export default BorangPmkKnpFormPegawaiPsmComponent;

